import { render, staticRenderFns } from "./restaurants.vue?vue&type=template&id=a550cb0a&scoped=true&"
import script from "./restaurants.vue?vue&type=script&lang=js&"
export * from "./restaurants.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/listing.css?vue&type=style&index=0&id=a550cb0a&scoped=true&lang=css&"
import style1 from "../../templateAssests/css/detail-page.css?vue&type=style&index=1&id=a550cb0a&scoped=true&lang=css&"
import style2 from "./restaurants.vue?vue&type=style&index=2&id=a550cb0a&scoped=true&lang=css&"
import style3 from "./restaurants.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550cb0a",
  null
  
)

export default component.exports